import { TMenuItemType } from '../../types/menu.types';
import { IFormOptionGroup, IFormPriceBand } from '../../types/menuItemForm.types';

export interface ICreateGlobalItemWizardProps {
  open: boolean;
  closeModal: () => void;
  menuId?: string;
  sectionId?: string;
}

export interface IGlobalItem {
  type: TMenuItemType;
  recipe_id: string | null;
  name: string;
  consumer_name: string;
  description: string;
  plu?: string | null;
  containsAlcohol?: boolean;
  image: File | string | null;
  tax_rate: string;
  price_bands?: IFormPriceBand[];
  modifier_groups: IFormOptionGroup[];
  ranges?: string[];
  is_hfss: boolean;
  age_verification: boolean;
  source: 'library' | 'ranges';
  deposit_return_scheme: string | null;
}

export enum Steps {
  type = 0,
  details = 1,
  tax = 2,
  bundleCategory = 3,
  bundlePricing = 4,
}
